import { useState, useEffect, useRef, useCallback } from "react";

export const useClientSearch = (options = {}) => {
  const {
    initialFilterBy = "clientName",
    debounceMs = 700,
    onDebouncedChange,
  } = options;

  const [filterBy, setFilterBy] = useState(initialFilterBy);

  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [shouldFocus, setShouldFocus] = useState(false);
  const searchInputRef = useRef(null);

  // Debounce del search
  useEffect(() => {
    const id = setTimeout(() => {
      const v = searchValue.trim();
      setDebouncedSearch(v);
      setShouldFocus(true);
      onDebouncedChange?.(v);
    }, debounceMs);
    return () => clearTimeout(id);
  }, [searchValue, debounceMs, onDebouncedChange]);

  // Autofocus suave tras actualizar el search debounced
  useEffect(() => {
    if (shouldFocus && searchInputRef.current) {
      const t = setTimeout(() => {
        searchInputRef.current?.focus();
        setShouldFocus(false);
      }, 100);
      return () => clearTimeout(t);
    }
  }, [shouldFocus]);

  // Handlers
  const handleSearchChange = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchValue("");
    setDebouncedSearch("");
    searchInputRef.current?.focus();
  }, []);

  const handleFilterByChange = useCallback((eOrValue) => {
    const value = typeof eOrValue === "string" ? eOrValue : eOrValue?.target?.value;
    if (value) setFilterBy(value);
  }, []);

  return {
    filterBy,
    setFilterBy,           
    handleFilterByChange,  

    // search
    searchValue,
    debouncedSearch,
    searchInputRef,
    handleSearchChange,
    handleClearSearch,
    setSearchValue,
  };
};
